
import Vuex from "vuex";
import Vue from "vue";
import { createDirectStore } from "direct-vuex";
import selectorStateModule from "./selectorStateModule";
import appStateModule from "./appStateModule";

Vue.use(Vuex);

const { store, rootActionContext, moduleActionContext } = createDirectStore({
    modules: {
        selectorStateModule,
        appStateModule
    }
});

export default store;

export { rootActionContext, moduleActionContext }

export type AppStore = typeof store
declare module "vuex" {
    interface Store<S> {
        direct: AppStore;
    }
}